import React from 'react';
import tick from '../assets/tick.png'

const Page = () => {
  document.body.style.overflow = 'hidden';

  const pageStyles = {
    backgroundColor: '#f9fafd',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '20px',
  };

  const containerStyles: any = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '5px',
    textAlign: 'center',
    maxWidth: '95%',
    minWidth: '90%',
    // boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)",
  };

  const textStyles = {
    fontSize: '24px',
    color: 'green',
    marginTop: '10px',
  };

  const subTextStyles = {
    fontSize: '16px',
    color: 'black',
    marginTop: '10px',
  };

  return (
    <div>
      <div style={containerStyles}>
        <div> <img src={tick} alt="" /> </div>
        <div style={textStyles}>Congratulations !!!</div>
        <div style={subTextStyles}>You have successfully completed the verification process</div>
      </div>
    </div>
  );
};

export default Page;